import { ReactNode } from "react";
import { PropertyManagementSystem } from "shared/types/partner";
import type { PaywallFeature } from "shared/app/BoomCrmPaywall/constants";

export interface Integration {
  id: string;
  name: string;
  icon: ReactNode;
  /**
   * Set when the partner lacks the entitlement this integration needs: the row
   * still renders, greyed out, with the paywall card on hover instead of
   * disappearing from the list (CRM-759).
   */
  lockedPaywall?: PaywallFeature;
}

export enum Step {
  FIRST,
  SECOND,
  THIRD
}

export enum IntegrationId {
  GA = "GA",
  GOOGLE_ADS = "GOOGLE_ADS",
  HUBSPOT = "HUBSPOT",
  CODEBOX = "CODEBOX",
  SENTRILOCK = "SENTRILOCK",
  IGLOOHOME = "IGLOOHOME",
  ZILLOW = "ZILLOW",
  ZUMPER = "ZUMPER",
  DWELLSY = "DWELLSY",
  APARTMENTS_COM = "APARTMENTS_COM",
  MHVILLAGE = "MHVILLAGE",
  BOOM_FINANCE = "BOOM_FINANCE",
  META_ADS = "META_ADS"
}

export const isPmsIntegration = (id: string): id is PropertyManagementSystem =>
  (Object.values(PropertyManagementSystem) as string[]).includes(id) &&
  id !== PropertyManagementSystem.Other;

// Integrations that skip the credentials step (direct connect or no creds needed)
export const DIRECT_CONNECT_INTEGRATIONS = new Set<
  PropertyManagementSystem | IntegrationId
>([
  IntegrationId.ZILLOW,
  IntegrationId.ZUMPER,
  IntegrationId.DWELLSY,
  IntegrationId.APARTMENTS_COM,
  IntegrationId.MHVILLAGE,
  IntegrationId.BOOM_FINANCE
]);
